import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=b6105574&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=js"
export * from "./CouponItem.vue?vue&type=script&lang=js"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=b6105574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6105574",
  null
  
)

export default component.exports